/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Intrangeaspect7Inputs */

const de__class_intrangeaspect7 = /** @type {(inputs: _Class_Intrangeaspect7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist zwischen`)
};

/**

* @param {_Class_Intrangeaspect7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_intrangeaspect7 = /** @type {((inputs?: _Class_Intrangeaspect7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Intrangeaspect7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_intrangeaspect7(inputs)
});
export { _class_intrangeaspect7 as "_class_IntRANGEAspect" }